import { Reveal } from "./Reveal";

const STEPS = [
  {
    num: "1",
    title: "We Review Your Profile",
    copy: "We examine your current listing and compare it with three relevant competitors in your area.",
  },
  {
    num: "2",
    title: "We Improve Your Content",
    copy: "We rewrite your description, clarify your services, and prepare customer-focused updates.",
  },
  {
    num: "3",
    title: "We Put It Into Action",
    copy: "With your approval and appropriate access, we update your profile and check the published information.",
  },
];

export const HowItWorks = () => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-5">How It Works</p>
        <h2 className="max-w-3xl text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
          Three Simple Steps to a Better Google Business Profile.
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.12}>
            <div data-testid={`step-${s.num}`} className="relative">
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -top-14 -left-2 font-heading text-[9rem] font-extrabold leading-none text-pine/10 select-none"
              >
                {s.num}
              </span>
              <div className="relative">
                <h3 className="text-2xl font-bold tracking-tight text-ink sm:text-3xl">
                  {s.title}
                </h3>
                <p className="mt-4 max-w-xs text-base text-soot">{s.copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
